export const SIDE_MENU_WIDTH = 260;
export const SIDE_MENU_SMALL_WIDTH = 80;
